import { useState } from "react";
import { Brand, ErrorBanner } from "./components";
import { post } from "./api";

export function Landing() {
  const [code, setCode] = useState("");
  const [error, setError] = useState<string>();
  const [busy, setBusy] = useState(false);
  return <main className="landing-page">
    <div className="landing-glow landing-glow--one" /><div className="landing-glow landing-glow--two" />
    <section className="landing-card">
      <Brand showSuffix={false} />
      <p className="eyebrow">LIVE INTERACTIVE ACTIVITIES</p>
      <h1>There’s <span>YOU</span> in PODIYOUM.</h1>
      <p className="lead">Enter the 6-character join code shown by the presenter.</p>
      <ErrorBanner message={error} onClose={() => setError(undefined)} />
      <form className="join-code-form" onSubmit={async (event) => {
        event.preventDefault(); setBusy(true); setError(undefined);
        try {
          const result = await post<{ secureToken: string }>("/api/join-code", { code });
          window.location.assign(`/j/${encodeURIComponent(result.secureToken)}`);
        } catch (caught) { setError(caught instanceof Error ? caught.message : "Could not join."); setBusy(false); }
      }}>
        <label htmlFor="join-code">Join code</label>
        <input id="join-code" className="code-input" value={code} onChange={(event) => setCode(event.target.value.toUpperCase().replace(/[^A-Z0-9]/g, "").slice(0, 6))} placeholder="123456" autoCapitalize="characters" autoComplete="off" maxLength={6} autoFocus />
        <button className="button button--primary button--wide" disabled={busy || code.length !== 6}>{busy ? "CHECKING…" : "JOIN NOW"}</button>
      </form>
    </section>
  </main>;
}
